import React, { useState, useEffect } from "react";
import { MdOutlineDarkMode } from "react-icons/md";
import { CiLight } from "react-icons/ci";

const ApiFetcher = ({ children }) => {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme]);

  function handleMode() {
    setTheme(theme === "dark" ? "light" : "dark");
  }

  return (
    <div className="transition-colors duration-500">
      <div className="shadow-xl py-4 bg-white dark:bg-slate-700">
        <div className="mx-6 flex justify-between items-center">
          <h3 className="text-lg font-bold">Where in The World</h3>
          <button
            onClick={handleMode}
            className="flex items-center space-x-2 px-4 py-2 bg-gray-200 dark:bg-gray-800 rounded-md"
          >
            {theme === "dark" ? (
              <>
                <CiLight className="text-yellow-500" />
                <span>Light Mode</span>
              </>
            ) : (
              <>
                <MdOutlineDarkMode className="text-gray-900" />
                <span>Dark Mode</span>
              </>
            )}
          </button>
        </div>
      </div>
      {children}
    </div>
  );
};

export default ApiFetcher;
